<template>
  <div>
    <div v-for="(payments, index) in fortnight" :key="index">
      <h4 v-if="title" class="grey--text">
        {{ $t(`hausefulInvoices.${title}`) }}
      </h4>

      <div>
        <h5 class="subtitle-1 grey--text text--darken-2 pl-1">
          <span class="d-block grey--text font-weight-bold caption mt-4 mb-n1">
            {{ $t('hausefulInvoices.realEstate') }}
          </span>
          {{ payments.real_estate.name }}
        </h5>
        <InvoiceBranch :payments="payments" />
      </div>
    </div>
  </div>
</template>

<script>
import InvoiceBranch from './InvoiceBranch'

export default {
  name: 'InvoiceFortnight',

  components: {
    InvoiceBranch,
  },

  props: {
    fortnight: {
      type: Array,
    },

    title: {
      type: String,
    },
  },
}
</script>
